// Multiply select

$(function () {
    function bind() {
        const facetedNavigation = $('.jsFacetedNavigation');

        facetedNavigation.each(function () {
            const $currentNavigation = $(this);
            const $navItems = $currentNavigation.find('.nav-item');
            const $selectTag = $('<select class="jsMultipleSelect custom-select" multiple />');

            $currentNavigation.after($selectTag);

            $navItems.each(function () {
                const $this = $(this);
                const $navLink = $this.find('.nav-link');
                const $option = $('<option>' + $this.text() + '</option>');
                const ajaxHref = $navLink.data('ajax-href');
                const href = $navLink.attr('href');

                $option.attr('value', href);
                $option.attr('data-ajax-href', ajaxHref);
                $option.prop('selected', $navLink.is('.active'));
                $selectTag.append($option);
            });

            $currentNavigation.remove();

        });

        const $multipleSelect = $('.jsMultipleSelect')
        $multipleSelect.select2({
            language: 'cs',
            width: '100%'
        });

        $multipleSelect.on("select2:select select2:unselect", function (e) {
            href = e.params.data.id;
            ajaxHref = $(e.params.data.element).data("ajax-href");
            $ajaxTarget = $(e.params.data.element).closest(".jsFacetedNavigationTarget");
            if ($ajaxTarget != "undefined") {
                EUCUtils.reload(ajaxHref, $ajaxTarget, href);
            }
            else {
                $(location).attr('href', href);
            }
            if (e.type == "select2:unselect") {
                $(this).data("unselecting", true)
            }
        }).on("select2:opening", function (e) {
            if ($(this).data("unselecting")) {
                $(this).removeData("unselecting");
                e.preventDefault()
            }
        });
    }
    bind();

    $(document).bind("reload:completed", bind);
});
